import { render, staticRenderFns } from "./userReport.vue?vue&type=template&id=1fd85e0f&scoped=true"
import script from "./userReport.vue?vue&type=script&lang=js"
export * from "./userReport.vue?vue&type=script&lang=js"
import style0 from "./userReport.vue?vue&type=style&index=0&id=1fd85e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8d78c4fc2b2e880cb3796fb82bca3a94/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd85e0f",
  null
  
)

export default component.exports